import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/filters/Single/settings/DataTab';

export const SingleFilterMainSettings = () => {
  return (
    <SettingsLayout>
      <DataTab />
    </SettingsLayout>
  );
};
